import { SVGProps } from 'react';

export const IconGuestList = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox='0 0 24 24' {...props}>
      <path
        d='M10.9687 11.125C12.6601 11.125 14.0312 9.7539 14.0312 8.06252C14.0312 6.37114 12.6601 5 10.9687 5C9.27732 5 7.90619 6.37114 7.90619 8.06252C7.90619 9.7539 9.27732 11.125 10.9687 11.125Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.8133 13.7429C14.5858 12.5831 12.3071 12.0001 10.9687 12.0001C9.07045 12.0001 5.28113 13.1726 5.28113 15.5001V17.2502H10.7227C10.2135 16.4802 10.2776 15.4345 10.9357 14.7307C11.7058 13.9071 12.9978 13.8637 13.8215 14.6339L14.4542 15.2255L15.8133 13.7429Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M19.4351 12.8133C19.7913 13.1398 19.8154 13.6933 19.4888 14.0496L15.211 18.7162C15.0532 18.8884 14.8331 18.9904 14.5997 18.9993C14.3663 19.0083 14.139 18.9236 13.9684 18.7641L11.8295 16.7641C11.4765 16.434 11.4579 15.8803 11.788 15.5274C12.1181 15.1744 12.6718 15.1558 13.0248 15.4858L14.5182 16.8823L18.1988 12.867C18.5254 12.5108 19.0789 12.4867 19.4351 12.8133Z'
        fill='currentColor'
      />
    </svg>
  );
};
